import * as React from 'react';
import { enableRipple } from '@syncfusion/ej2-base';
import {
  ContextMenuComponent,
  TreeViewComponent,
} from '@syncfusion/ej2-react-navigations';
import {
  DialogComponent,
  ButtonPropsModel,
  AnimationSettingsModel,
} from '@syncfusion/ej2-react-popups';
import './style.css';
import {
  IoAddSharp,
  IoCheckmarkDoneOutline,
  IoRefresh,
  IoTrashOutline,
} from 'react-icons/io5';
import { GoPencil } from 'react-icons/go';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { toast } from 'react-toastify';
import Message from '../../utils/Message/Message';
import { all_information, loadingShow } from '../../App';
import { ThemeContext } from '../../context/theme.context';
import Scheduler from '../../components/GlobalScheduler';
import {
  getAssignments,
  getAssignmentsDetails,
} from '../../services/assignments/assignmentService';
import {
  createTeam,
  getTeams,
  getTeamsDetail,
  teamDelete,
  teamUpdate,
} from '../../services/TradePlanner/Team/TeamServices';
import { getTeamAssigments } from '../../services/tradeperson/team';
import GenerateCapacity from '../../utils/GenerateCapacity';
import { searchNodes } from '../../utils/GetFilterItems';
import { GetAssignmentOfTheTrade } from '../../services/TradePlanner/Trades/TradesServices';
import { assign, upperCase } from 'lodash';
enableRipple(true);
interface IProps {}

interface TeamInterface {
  hasChild: boolean | undefined;
  id: number | undefined;
  name: string | undefined;
  pid: string | undefined;
  team_id: number | undefined;
  trade_id: string | undefined;
}

type Fields = {
  dataSource: any;
  id: any;
  parentID: any;
  text: any;
  hasChildren: any;
  htmlAttributes: any;
};
interface IState {
  fields: Fields;
  hideDialogTeam: boolean;
  hideDialogDelete: boolean;
  hideDialogEdit: boolean;
  hideDialogAdd: boolean;
  teamsData: any;
  AssignmentData: any;
  selectedAssignments: Array<any>;
}
export default class Team extends React.Component<IProps, IState> {
  private allowDragAndDrop: boolean = true;
  private isChecked: boolean = true;
  private treeObj: any;
  public menuObjTeam: any;
  public menuItemsTeam: any;
  private buttonsTeamAdd: ButtonPropsModel[];
  private buttonsDelete: ButtonPropsModel[];
  private buttonsEdit: ButtonPropsModel[];
  private animationSettingsTeam: AnimationSettingsModel;
  public dialogInstanceTeam: any;
  public selectedNameTeam: string;
  private inputName: string = '';
  private inputDescription: string = '';
  private teamId: number = -1;
  checkedNodes: any;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private assignmentId = -1;
  private current_team_trade_ids: Array<any> = [];
  private current_teams: Array<any> = [];
  private teamsFromBackend: [] = [];
  private CheckedBoxSelectedTeam: TeamInterface[] = [];
  constructor(props: IProps) {
    super(props);
    this.treeObj = new TreeViewComponent(props);
    this.menuObjTeam = new ContextMenuComponent(props);
    this.dialogInstanceTeam = new DialogComponent(props);
    this.selectedNameTeam = '';
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteTeam();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDelete: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsEdit = [
      {
        click: () => {
          this.editTeam();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogEdit: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsTeamAdd = [
      {
        click: () => {
          this.createTeam();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogAdd: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.animationSettingsTeam = { effect: 'Zoom', duration: 400, delay: 0 };
    this.menuItemsTeam = [
      {
        text: 'Assign Shift Element',
      },
    ];
    this.state = {
      teamsData: [],
      hideDialogEdit: false,
      hideDialogDelete: false,
      fields: {
        dataSource: [],
        id: 'id',
        parentID: 'pid',
        text: 'name',
        hasChildren: 'hasChild',
        htmlAttributes: 'htmlAttributes',
      },
      hideDialogTeam: false,
      hideDialogAdd: false,
      AssignmentData: [],
      selectedAssignments: [],
    };
  }
  componentDidMount() {
    this.getTeamsData();
    getTeams().then((result) => {
      this.teamsFromBackend = result.data.filter(
        (eachData: any) => eachData.pid == null
      );
      this.setState({ teamsData: result.data });
    });
  }

  componentDidUpdate() {
    if (this.context.isDataChangeTeam) {
      this.getTeamsData();
      this.context.setDataChangeTeam(false);
    }
  }
  setTradeTeamAffected = () => {
    this.context.setDataChangeTrade(true);
    this.context.setDataChangeTeam(true);
    this.context.setDataChange(true);
  };
  private getTeamsData() {
    getTeams().then((res) => {
      var data = res.data.map((result: any) => {
        return {
          ...result,
          htmlAttributes: {
            team_trade_id: JSON.stringify([
              { team_id: result.team_id },
              { trade_id: result.trade_id },
              { assignment_id: result.id },
            ]),
          },
        };
      });
      var model = {
        dataSource: data,
        id: 'id',
        parentID: 'pid',
        text: 'name',
        hasChildren: 'hasChild',
        htmlAttributes: 'htmlAttributes',
      };
      this.setState({ fields: model });
    });
  }
  private deleteTeam() {
    if (this.CheckedBoxSelectedTeam.length == 0) {
      toast.error('Team was not selected be empty');
      loadingShow(false);
      return false;
    }
    // let obj = {
    //   team_id: teamID,
    // };
    let obj = this.CheckedBoxSelectedTeam.map((eachTeamObject) => {
      console.log(eachTeamObject);
      return eachTeamObject.team_id;
    });

    teamDelete(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Deleted  successfully...');
        this.current_team_trade_ids[0] = null;
        this.getTeamsData();
        this.context.setDataChangeTeam(true);
        this.setTradeTeamAffected();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Operation failed!!!');
      });
    this.dialogCloseDelete();
  }

  private editTeam() {
    var teamCode = this.inputName;
    var teamDescription = this.inputDescription;
    var teamID = this.teamId;
    if (teamCode === '') {
      toast.error('Team Name cannot be empty');
      loadingShow(false);
      return false;
    }
    if (teamDescription === '') {
      toast.error('Team Description cannot be empty');
      loadingShow(false);
      return false;
    }

    let obj = {
      team_code: teamCode,
      description: teamDescription,
      team_id: Number(teamID),
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      creation_date: new Date(),
    };
    teamUpdate(obj)
      .then((result) => {
        if (result.status === 200) {
          loadingShow(false);
          Message.success('Edited successfully...');
          this.getTeamsData();
          this.context.setDataChangeTeam(true);
        }
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Editing failed!!!');
      });

    this.dialogCloseEdit();
  }
  private dialogCloseDelete(): void {
    this.setState({
      hideDialogDelete: false,
    });
  }

  private dialogCloseEdit(): void {
    this.setState({
      hideDialogEdit: false,
    });
  }
  private dialogCloseTeamAdd(): void {
    this.setState({ hideDialogAdd: false });
  }
  private dialogOpenTeamAdd(): void {
    this.setState({ hideDialogAdd: true });
  }
  private menuclickTeam(argss: any) {
    //let targetNodeId = this.treeObj.selectedNodes[0];
    if (argss.item !== undefined) {
      if (argss.item.text === 'Assign Shift Element') {
        let theDatas = this.current_team_trade_ids;
        loadingShow(true, 'Preparing...');
        if (theDatas[0].team_id === null && theDatas[1].trade_id === null) {
          this.getAssignmentsData(theDatas[2].assignment_id);
          return;
        }
        if (theDatas[1].trade_id !== null) {
          GetAssignmentOfTheTrade(theDatas[1].trade_id)
            .then((res) => {
              let theIds = [
                ...res.data.map((el: any) => el.assignment_id),
              ].toString();
              this.getAssignmentsData(theIds);
            })
            .catch((er) => {
              console.log('Error occured.Please try again later');
              loadingShow(false);
            });
          return;
        }
        if (theDatas[0].team_id === null && theDatas[1].trade_id === null) {
          Message.error(
            'This node not suitable to create any activity. Try another one.'
          );
          return;
        }
        if (theDatas[0].team_id === null) {
          Message.error(
            'This node not suitable to create any activity. Try another one.'
          );
          return;
        }
        let names: Array<string> = [];
        getTeamAssigments(theDatas[0].team_id)
          .then((res: any) => {
            let theIds = [
              ...res.data.map((el: any) => el.assignment_id),
            ].toString();
            if (theIds.length > 0) {
              this.getAssignmentsData(theIds);
            } else {
              loadingShow(false);
              Message.info('No Trade Person To Add Shift');
              return;
            }
          })
          .catch((er) => {});
      } else if (argss.item.text === 'Teams Exception') {
      }
    }
  }
  private getAssignmentsData = (theIds: string) => {
    getAssignmentsDetails(theIds)
      .then((el) => {
        loadingShow(false, 'Preparing...');
        this.activateCapacityGeneration(el.data);
      })
      .catch((e) => {
        loadingShow(false, 'Preparing...');
      });
  };
  private activateCapacityGeneration = (data: any) => {
    this.setState({
      selectedAssignments: data,
      hideDialogTeam: true,
    });
  };
  private nodeChecked(args: any) {
    Scheduler.StoreTeam = [];
    Scheduler.StoreTeam.push(...this.checkedNodes);
  }
  private AddTeamOpenModal = () => {
    this.dialogOpenTeamAdd();
  };
  private EditTeamOpenModal = async () => {
    var theTreeObj = this.treeObj as TreeViewComponent;

    let counter: number = 0;
    var checkednodes = theTreeObj.getAllCheckedNodes();
    var SelectedTeam: TeamInterface = {
      hasChild: false,
      id: 0,
      name: '',
      pid: '',
      team_id: undefined,
      trade_id: '',
    };
    this.teamsFromBackend.map((eachTeam: TeamInterface, index: number) => {
      checkednodes.map((eachnode) => {
        if (eachTeam.id && eachTeam.id.toString() == eachnode) {
          counter++;
          SelectedTeam = eachTeam;
        }
      });
    });

    if (counter != 1) {
      Message.info('Select 1 Team ');
      return;
    }
    if (SelectedTeam.team_id != undefined) {
      loadingShow(true, 'Preparing...');
      // let theDatas = this.current_team_trade_ids;

      if (SelectedTeam.team_id === null && SelectedTeam.trade_id === null) {
        Message.error(
          'This node not suitable to create any activity. Try another one.'
        );
        return;
      }
      if (SelectedTeam.team_id === null) {
        Message.error('This node not suitable to edit. Try another one.');
        return;
      }
      getTeamsDetail(SelectedTeam.team_id.toString())
        .then((e) => {
          loadingShow(false);
          this.teamId = e.data.team_id;
          this.inputName = e.data.team_code;
          this.inputDescription = e.data.description;
          this.setState({ hideDialogEdit: true });
        })
        .catch((e) => {
          loadingShow(false);
          Message.error('Error occured');
          //(e);
        });
    } else {
      Message.error('No selected any team to edit');
    }
  };
  private DeleteTeamOpenModal = async () => {
    let counter: number = 0;
    var theTreeObj = this.treeObj as TreeViewComponent;
    var checkednodes = theTreeObj.getAllCheckedNodes();
    this.CheckedBoxSelectedTeam = [];
    this.teamsFromBackend.map((eachTeam: TeamInterface, index: number) => {
      checkednodes.map((eachnode) => {
        if (eachTeam.id && eachTeam.id.toString() == eachnode) {
          console.log('if girdi');
          counter++;
          this.CheckedBoxSelectedTeam.push(eachTeam);
        }
      });
    });

    if (this.CheckedBoxSelectedTeam.length > 0) {
      // this.teamId = SelectedTeam.team_id;
      this.setState({ hideDialogDelete: true });
    } else {
      Message.error('No selected any team to delete');
    }
  };
  private async createTeam() {
    var TeamCode = this.inputName;
    var teamDescription = this.inputDescription;

    if (TeamCode === '') {
      toast.error('Team Name cannot be empty');
      loadingShow(false);
      return false;
    }

    if (teamDescription === '') {
      toast.error('Team Description cannot be empty');
      loadingShow(false);
      return false;
    }

    loadingShow(true);

    try {
      const res = await getTeams();
      let teams: { name?: string; pid?: number }[] = res.data;

      console.log('Teams data:', teams);

      const teamExists = teams.some(
        (eachteam) =>
          (eachteam.pid === null || eachteam.pid === undefined) &&
          eachteam.name?.toUpperCase() === TeamCode.toUpperCase()
      );

      console.log('teamExists:', teamExists);

      if (teamExists) {
        Message.error('Same Team Already Exist');
        loadingShow(false);
        return false;
      }

      delete all_information.rowstamp;

      let obj = {
        team_code: TeamCode,
        description: teamDescription,
        app: 'UWORK',
        created_by: all_information.user_id,
        organization_id: all_information.company_id?.toString(),
        creation_date: new Date(),
      };

      await createTeam(obj);

      loadingShow(false);
      Message.success('Added successfully...');
      this.context.setDataChangeTeam(true);
      this.getTeamsData();
    } catch (err) {
      loadingShow(false);
      Message.error('Add failed!!!');
      console.error(err);
    }

    this.dialogCloseTeamAdd();
  }

  private nodeclicked(args: any) {
    const assignmentId2 = Number(args.node.getAttribute('data-uid'));
    this.current_team_trade_ids = JSON.parse(
      args.node.getAttribute('team_trade_id')
    );
    this.assignmentId = assignmentId2;

    let allAssignmentData: Array<any> = [];
    let allJustAssignmentId: Array<any> = [];
    if (this.assignmentId >= 100000 && this.assignmentId <= 199999) {
      const resultTrade = this.state.teamsData.filter((el: any) => {
        return el.pid === Number(this.assignmentId) && el.trade_id !== 0;
      });
      // TEAM Operations
      let resultTeam: Array<any> = this.state.teamsData.filter((el: any) => {
        return el.id === Number(this.assignmentId) && el.team_id !== null;
      });

      let checkedNodes: Array<any> = this.treeObj.getAllCheckedNodes();
      if (
        !this.treeObj
          .getAllCheckedNodes()
          .includes(this.assignmentId.toString())
      ) {
        resultTeam = checkedNodes.filter((item) => item === this.assignmentId);
      }
      resultTeam = checkedNodes.filter(
        (item) => item >= 100000 && item <= 199999 && item !== this.assignmentId
      );

      let teamAllDatas: Array<any> = [];
      resultTeam.map((id: any) => {
        for (var i = 0; i < this.state.teamsData.length; i++) {
          if (id === this.state.teamsData[i].id.toString()) {
            teamAllDatas.push(this.state.teamsData[i]);
          }
        }
      });
      this.current_teams = teamAllDatas;
      //
      resultTrade.map((elRes1: any) => {
        const resultAssignment = this.state.teamsData.filter((el: any) => {
          return el.pid === Number(elRes1.id);
        });
        allAssignmentData.push(...resultAssignment);
      });
    } else if (this.assignmentId >= 200000) {
      const resultTrade = this.state.teamsData.filter((el: any) => {
        return el.pid === Number(this.assignmentId) && el.trade_id !== 0;
      });
      allAssignmentData.push(...resultTrade);
    } else if (this.assignmentId < 100000) {
      allJustAssignmentId.push(this.assignmentId);
    }
    allAssignmentData.map((el) => {
      allJustAssignmentId.push(el.id);
    });
  }
  changeDataSource(data: any) {
    this.setState({
      fields: {
        dataSource: data,
        id: 'id',
        parentID: 'pid',
        text: 'name',
        hasChildren: 'hasChild',
        htmlAttributes: 'htmlAttributes',
      },
    });
  }
  searchNodes(args: any) {
    searchNodes(
      args.value,
      this.state.teamsData,
      this.changeDataSource.bind(this),
      'name',
      'id'
    );
  }
  render() {
    return (
      <div>
        <div className='teams-header-crud'>
          <h5 className='teams-baslik'>TEAMS</h5>
          <div className='team-crud'>
            <div className='add-team'>
              <IoAddSharp onClick={this.AddTeamOpenModal} size={17} />
            </div>
            <div className='edit-team'>
              <GoPencil onClick={() => this.EditTeamOpenModal()} size={17} />
            </div>
            <div className='delete-team'>
              <IoTrashOutline
                onClick={() => this.DeleteTeamOpenModal()}
                size={17}
              />
            </div>
            <div className='refresh-assignment'>
              <IoRefresh
                onClick={() => {
                  this.checkedNodes = [];
                  Scheduler.StoreTeam = [];
                  this.treeObj.uncheckAll();

                  this.getTeamsData();
                  this.context.setDataChangeTeam(false);
                }}
                size={17}
              />
            </div>
            <div className='uncheck-team'>
              <IoCheckmarkDoneOutline
                onClick={() => {
                  this.checkedNodes = [];
                  Scheduler.StoreTrades = [];
                  this.treeObj.uncheckAll();
                }}
                size={17}
              />
            </div>
          </div>
        </div>
        <div className='searchAssign'>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              alignSelf: 'flex-end',
              height: 25,
            }}
          >
            <TextBoxComponent
              type={'text'}
              id='team_search'
              autocomplete='off'
              // input={this.searchNodes.bind(this)}
              showClearButton
              placeholder='Search'
              onChange={this.searchNodes.bind(this)}
            />
            <div
              style={{
                borderRightColor: 'transparent',
                borderTopColor: 'transparent',
                borderBottomColor: 'transparent',
              }}
            ></div>
          </div>
        </div>
        <div id='treeTeamOverflow'>
          <TreeViewComponent
            id='treeTeam'
            fields={this.state.fields}
            ref={(treeview) => {
              this.treeObj = treeview;
            }}
            allowDragAndDrop={this.allowDragAndDrop}
            showCheckBox={this.isChecked}
            nodeChecked={this.nodeChecked}
            nodeClicked={this.nodeclicked.bind(this)}
            dragArea={document.getElementById('SplitterInner') as HTMLElement}
          />
          <ContextMenuComponent
            id='contentmenutree'
            target='#treeTeam'
            items={this.menuItemsTeam}
            select={this.menuclickTeam.bind(this)}
            ref={(contextmenuTeam) => {
              this.menuObjTeam = contextmenuTeam;
            }}
          />
          <div className='control-pane-dialog'>
            <div
              id='targetElement'
              className='col-lg-12 defaultDialog dialog-target'
            >
              {this.state.hideDialogTeam ? (
                <GenerateCapacity
                  assignments={this.state.selectedAssignments}
                  hideDialog={this.state.hideDialogTeam}
                  setHideDialogCapacity={(val) =>
                    this.setState({ hideDialogTeam: val })
                  }
                />
              ) : null}
            </div>
          </div>
          <div className='control-pane-dialogAdd'>
            <div
              id='targetElementAddTeam'
              className='col-lg-12 defaultDialogAddTeam dialog-target'
            >
              {this.state.hideDialogDelete ? (
                <DialogComponent
                  isModal={true}
                  id='defaultDialogDelete'
                  showCloseIcon={true}
                  animationSettings={this.animationSettingsTeam}
                  visible={this.state.hideDialogDelete}
                  header='Confirmation'
                  width={200}
                  height={'auto'}
                  buttons={this.buttonsDelete}
                  open={() => {
                    this.setState({ hideDialogDelete: true });
                  }}
                  close={() => {
                    this.setState({ hideDialogDelete: false });
                  }}
                >
                  <div className='container'>
                    <div className='row'>
                      <span>Do You Want To Delete This Team?</span>
                    </div>
                  </div>
                </DialogComponent>
              ) : null}

              {this.state.hideDialogEdit ? (
                <DialogComponent
                  isModal={true}
                  id='defaultDialogAddTeam'
                  showCloseIcon={true}
                  animationSettings={this.animationSettingsTeam}
                  visible={this.state.hideDialogEdit}
                  width={'400px'}
                  header='Team Editing'
                  buttons={this.buttonsEdit}
                  open={() => {
                    this.setState({ hideDialogEdit: true });
                  }}
                  close={() => {
                    this.setState({ hideDialogEdit: false });
                  }}
                >
                  <div className='row mb-3'>
                    <div className='col-md-3'>Team Name:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputName = e.value;
                        }}
                        value={this.inputName}
                        placeholder='Enter Name'
                      />
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='col-md-3'>Description:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputDescription = e.value;
                        }}
                        value={this.inputDescription}
                        placeholder='Enter Description'
                      />
                    </div>
                  </div>
                </DialogComponent>
              ) : null}

              {this.state.hideDialogAdd ? (
                <DialogComponent
                  isModal={true}
                  id='defaultDialogAddTeam'
                  showCloseIcon={true}
                  animationSettings={this.animationSettingsTeam}
                  visible={this.state.hideDialogAdd}
                  width={'400px'}
                  header='Team'
                  buttons={this.buttonsTeamAdd}
                  open={this.dialogOpenTeamAdd.bind(this)}
                  close={this.dialogCloseTeamAdd.bind(this)}
                >
                  <div className='row mb-3'>
                    <div className='col-md-3'>Team Name:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputName = e.value;
                        }}
                        placeholder='Enter Name'
                      />
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='col-md-3'>Description:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputDescription = e.value;
                        }}
                        placeholder='Enter Description'
                      />
                    </div>
                  </div>
                </DialogComponent>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
